import EmptyDocuments from '@Assets/Images/empty-documents.svg';
import { AssetDocument } from '@Types/Asset.types';
import { FILENAME_REGEX } from '@Utils/constants';
import { downloadDocument } from '@Utils/document.utils.ts';
import { applyRegex } from '@Utils/format.utils.tsx';
import { Button, Icons, Modal, SectionCard } from '@kg-internal/pv3-uikit';

type Props = {
  show: boolean;
  onClose: () => void;
  documents?: AssetDocument[];
};

const AssetDocumentsModal = ({ show, onClose, documents }: Props) => (
  <Modal clickOutside onClose={onClose} show={show} showClose title='Documents'>
    {documents && documents.length > 0 ? (
      documents.map((doc) => (
        <SectionCard className='content-between-md' key={doc.filename}>
          <p>{doc.filename ? applyRegex(doc.filename, FILENAME_REGEX) : ''}</p>
          <Button onClick={() => downloadDocument(doc.url)} className='button-with-icon'>
            {Icons.Download} Download
          </Button>
        </SectionCard>
      ))
    ) : (
      <div className='content-center content-100'>
        <div className='text-center'>
          <img src={EmptyDocuments} alt='No documents' />
          <h1>No documents found</h1>
        </div>
      </div>
    )}
  </Modal>
);

export default AssetDocumentsModal;
